import React from 'react';
import { Box, Typography, Avatar, Stack, Grid } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const testimonials = [
  {
    name: 'Arun Menon',
    location: 'Kochi',
    review:
      '“I was unsure about buying a used car from OLX, but FOCUS Inspection gave me full confidence. The report was detailed, and the warranty gave me peace of mind”',
  },
  {
    name: 'Shahana Rafiq',
    location: 'Calicut',
    review:
      'Their team reached the seller’s location and did a full inspection in front of me. Super professional. Now I recommend FOCUS to all my friends!',
  },
  {
    name: 'Rahul Dev',
    location: 'Thrissur',
    review:
      'I had a mechanic check lined up, but I went with FOCUS instead—and I’m glad I did. They found issues I would’ve missed. Totally worth it!',
  },
];

const ReviewSectionWeb = () => (
  <Box sx={{ px: '100px', py: 10, backgroundColor: 'white' }}>
    <Grid container spacing={12} justifyContent="center" pl="60px">
      {testimonials.map((item, idx) => (
        <Grid item xs={12} md={4} key={idx}>
          <Box>
            {/* Stars */}
            <Stack direction="row" spacing={0.5} mb={1}>
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} sx={{ color: '#FFCE31', fontSize: 20 }} />
              ))}
            </Stack>

            {/* Review Text */}
            <Typography fontSize="13px" mb={2} fontWeight="500" color="#000000" lineHeight="20px">
              {item.review}
            </Typography>

            {/* Avatar + Name + Location */}
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar
                src={`assets/images/Inspection/person.png`} // 🔹 replace with actual image paths
                sx={{ width: 57, height: 57 }}
              />
              <Box>
                <Typography fontSize="13px" fontWeight="800" color="#0D0D0D">
                  {item.name}
                </Typography>
                <Typography fontSize="10px" color="#A0A0A0">
                  {item.location}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default ReviewSectionWeb;
